import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueToast from 'vue-toast-notification'
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css';
import Auth from './components/home/Auth'
import AuthCreate from './components/home/FormRegister.vue';
import AuthLogin from './components/home/FormLogin.vue';
import AuthNewStudent from './components/home/AlunoRegister.vue';

Vue.config.productionTip = false
Vue.use(ElementUI, {
  locale
});

Vue.use(VueToast, {
  // global options
});

Vue.component('Auth', Auth);
Vue.component('UserFormCreate', AuthCreate);
Vue.component('UserFormLogin', AuthLogin);
Vue.component('NewStudent', AuthNewStudent);

export const bus = new Vue()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')